import type { HttpError } from "@refinedev/core";

/** An error answer from apps/api: `{ code, message }` with a Turkish message. */
export class ApiError extends Error implements HttpError {
  constructor(
    readonly statusCode: number,
    readonly code: string,
    message: string,
  ) {
    super(message);
  }
}

/** Calls apps/api on the same origin (the reverse proxy forwards /api). */
export async function api<T>(
  path: string,
  options: { method?: string; body?: unknown } = {},
): Promise<T> {
  const response = await fetch(path, {
    method: options.method ?? "GET",
    credentials: "same-origin",
    headers: options.body === undefined ? undefined : { "Content-Type": "application/json" },
    body: options.body === undefined ? undefined : JSON.stringify(options.body),
  });
  if (response.status === 204) return undefined as T;
  const data: unknown = await response.json().catch(() => null);
  if (!response.ok) {
    const error = (data ?? {}) as { code?: string; message?: string };
    throw new ApiError(
      response.status,
      error.code ?? "ERROR",
      error.message ?? "Beklenmeyen bir hata oluştu. Tekrar dene.",
    );
  }
  return data as T;
}
